import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updatePriority } from '../../../../state';
import { useGetTicketPrioritiesQuery } from '../../../../../../services/DimensionService/dimensionApi';

const PriorityEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentRecurringTask } = useAppSelector(state => state.recurringTask);
  const { data: priorities, isLoading, error } = useGetTicketPrioritiesQuery();

  const handleChange = (event: any) => {
    dispatch(updatePriority(event.target.value));
  };

  return (
    <FormControl size="small" sx={{ minWidth: 150 }}>
      <InputLabel>Priority</InputLabel>
      <Select
        value={currentRecurringTask?.priority || 'MED'}
        onChange={handleChange}
        label="Priority"
        disabled={isLoading || !!error}
      >
        {isLoading ? (
          <MenuItem disabled>
            <CircularProgress size={20} sx={{ mr: 1 }} />
            Loading priorities...
          </MenuItem>
        ) : error ? (
          <MenuItem disabled>Error loading priorities</MenuItem>
        ) : (
          priorities?.map((priority) => (
            <MenuItem key={priority.value} value={priority.value}>
              {priority.name}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default PriorityEdit;
